// import { set } from "../../utils";
import { isAgent } from "../../utils/nick-utils";
import { ChatMemberJoinDetail } from "../ChatAction";
import { ChatState } from "../ChatState";
import { joinMessages } from "./joinMessages";

export function memberJoin(state: ChatState, detail: ChatMemberJoinDetail): ChatState {
    // TODO: Why?
    // if (state.chats.length === 0) {
        // console.log(`######### No chats in member join action`);
        // set("sessionId", "");
    // }

    const agents = { ...state.agents };
    const prevAgentInfo = state.agents[detail.user.nick];
 
    agents[detail.user.nick] = {
        ...prevAgentInfo,
        user: {
            ...detail.user,
            displayName: detail.user.displayName || "Agent",
        },
        joined: true,
        typing: false
    };

    if (isAgent(detail.user.nick)) {
        return {
            ...state,
            isChatting: true,
            chats: prevAgentInfo?.joined ? state.chats : joinMessages(state.chats, detail),
            agents
        };
    } else {
        return {
            ...state,
            isChatting: true,
            chats: joinMessages(state.chats, detail),
            agents
        };
    }
}
